import React from 'react';
import Image from '@atlaskit/image';
import { useIntl } from '@atlassian/jira-intl';
import messages from '../messages.tsx';
import RequestAccessLock from './request-access-lock.svg';

export const RequestAccessImage = () => {
	const { formatMessage } = useIntl();
	return <Image src={RequestAccessLock} alt={formatMessage(messages.requestAccessAltText)} />;
};
